import type { PartnerName } from '@jerry-serverless/analyticslib/partner';

import { CarIcon } from '../../../components/icon/car_icon/CarIcon';
import { CarHouseIcon } from '../../../components/icon/car_house_icon/CarHouseIcon';
import { CarAptIcon } from '../../../components/icon/car_apt_icon/CarAptIcon';
import type { ShopForType } from '../../../types/app_data';

export interface ShopForOptionsType {
  title: string;
  icon: React.FunctionComponent;
  shopForValue: ShopForType;
  isSelected: (shopFor?: ShopForType) => boolean | undefined;
  trackLabel?: string;
}

/**
 * List of 'shop for options' to be used per partner in 'shopFor' step.
 */
const SHOP_FOR_OPTIONS = {
  default: [
    {
      title: 'Car',
      icon: CarIcon,
      shopForValue: { home: false, renters: false, condo: false, umbrella: false },
      isSelected: (shopFor?: ShopForType) => shopFor && !shopFor.home && !shopFor.renters,
      trackLabel: 'Car',
    },
    {
      title: 'Car + Home',
      icon: CarHouseIcon,
      shopForValue: { home: true, renters: false, condo: false, umbrella: false },
      isSelected: (shopFor?: ShopForType) => shopFor && shopFor.home,
      trackLabel: 'Home',
    },
    {
      title: 'Car + Renters',
      icon: CarAptIcon,
      shopForValue: { home: false, renters: true, condo: false, umbrella: false },
      isSelected: (shopFor?: ShopForType) => shopFor && shopFor.renters,
      trackLabel: 'Renters',
    },
  ],
  mykukun: [
    {
      title: 'Home + Car',
      icon: CarHouseIcon,
      shopForValue: { home: true, renters: false, condo: false, umbrella: false },
      isSelected: (shopFor?: ShopForType) => shopFor && shopFor.home,
      trackLabel: 'Home',
    },
    {
      title: 'Renters + Car',
      icon: CarAptIcon,
      shopForValue: { home: false, renters: true, condo: false, umbrella: false },
      isSelected: (shopFor?: ShopForType) => shopFor && shopFor.renters,
      trackLabel: 'Renters',
    },
    {
      title: 'Car',
      icon: CarIcon,
      shopForValue: { home: false, renters: false, condo: false, umbrella: false },
      isSelected: (shopFor?: ShopForType) => shopFor && !shopFor.home && !shopFor.renters,
    },
  ],
};

/**
 * Grab 'ShopForOptions' per partner.
 * @param partnerName
 */
export const getShopForOptions = (partnerName: PartnerName | 'default' = 'default'): ShopForOptionsType[] =>
  SHOP_FOR_OPTIONS[partnerName] || SHOP_FOR_OPTIONS['default'];
